module.exports = __webpack_public_path__ + "static/img/CR.c2065a86.svg";